export { Menu } from './Menu';
export type { Link } from './Menu.types';
